import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sidebar-logo-link"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: "expand",
  class: "sidebar-logo-link"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "sidebar-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sidebar-logo-container", { 'collapse': $setup.isCollapse }])
  }, [
    _createVNode(_Transition, { name: "sidebarLogoFade" }, {
      default: _withCtx(() => [
        ($setup.isCollapse)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              ($setup.logo_b)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: $setup.logo_b,
                    class: "sidebar-logo"
                  }, null, 8, _hoisted_2))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", null, [
                ($setup.logo)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: $setup.logo,
                      class: "sidebar-logo"
                    }, null, 8, _hoisted_4))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("h1", _hoisted_5, _toDisplayString($setup.title), 1)
            ]))
      ]),
      _: 1
    })
  ], 2))
}